import { useEffect, useCallback } from 'react';

export function useUnsavedChangesWarning(
  unsavedChanges: boolean,
  message = '변경사항이 저장되지 않았습니다. 정말로 나가시겠습니까?',
) {
  const onBeforeUnload = useCallback(
    (e: BeforeUnloadEvent) => {
      if (unsavedChanges) {
        e.preventDefault();
        e.returnValue = message;
      }
    },
    [unsavedChanges, message],
  );

  useEffect(() => {
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [onBeforeUnload]);
}
